import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './FIIStatistics.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import MarketFandO from "../../MarketFandO";
import { format, parseISO } from 'date-fns';
import { Vortex } from 'react-loader-spinner'



function FIIStatistics() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {

        setloadingshow(true);
        
        window.scrollTo(0, 0)
        const getUrl = BaseURL + "Fiistatistics";


        fetch(`${getUrl}`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                // console.log(getData, "getData")
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>FII Statistics</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='FIISta-loser-sc'>
                            <div className='FIISta-header'>
                                <h2><span>FII Statistics</span></h2>
                            </div>
                            <MarketFandO optionValue="FII Statistics" optionDrop="Derivative" />
                            {/* <hr className="Mosthr"></hr> */}
                            <div className='FIISta-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left bdrright'></th>
                                            <th className='text-center bdrright bdrbottom' colspan="2">Buy</th>
                                            <th className='text-center bdrright bdrbottom' colspan="2">Sell </th>
                                            <th className='text-right bdrright bdrbottom'>Net Buy / Sell Value</th>
                                            <th className='text-center bdrbottom' colspan="2">Open Interest (EOD)</th>
                                        </tr>
                                        <tr>
                                            <th className='bdrright'>Details </th>
                                            <th className='text-right bdrright'>No. of Contracts</th>
                                            <th className='text-right bdrright'>Value (Rs Cr.)</th>
                                            <th className='text-right bdrright'>No. of Contracts</th>
                                            <th className='text-right  bdrright'>Value (Rs Cr.) </th>
                                            <th className='text-right bdrright'>(Rs Cr.)</th>
                                            <th className='text-right bdrright'>No. of Contracts</th>
                                            <th className='text-right'>Value (Rs Cr.) </th>
                                        </tr>

                                    </thead>
                                    {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                    <tbody>
                                        {currentTableData && currentTableData.map(

                                            ({ Ifbuycon, ifbuyval, ifsellcon, ifsellval, ifbuyoicon, ifbuyoival }) => (
                                                <tr>
                                                    <td className="text-left">Index Futures</td>
                                                    <td className="text-right">{(Ifbuycon != null) ? Ifbuycon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(ifbuyval != null) ? ifbuyval.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(ifsellcon != null) ? ifsellcon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(ifsellval != null) ? ifsellval.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(ifbuyval != null && ifsellval != null) ? ((ifbuyval - ifsellval).toFixed(2)) : 0}</td>
                                                    <td className="text-right"> {(ifbuyoicon != null) ? ifbuyoicon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(ifbuyoival != null) ? ifbuyoival.toFixed(2) : 0}</td>
                                                </tr>
                                            ))}
                                        {currentTableData && currentTableData.map(
                                            ({ Iobuycon, iobuyval, iosellcon, iosellval, iobuyoicon, iobuyoival }) => (
                                                <tr>
                                                    <td className="text-left">Index Options</td>
                                                    <td className="text-right">{(Iobuycon != null) ? Iobuycon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(iobuyval != null) ? iobuyval.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(iosellcon != null) ? iosellcon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(iosellval != null) ? iosellval.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(iobuyval != null && iosellval != null) ? ((iobuyval - iosellval).toFixed(2)) : 0}</td>
                                                    <td className="text-right"> {(iobuyoicon != null) ? iobuyoicon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(iobuyoival != null) ? iobuyoival.toFixed(2) : 0}</td>
                                                </tr>
                                            ))}
                                        {currentTableData && currentTableData.map(
                                            ({ sfbuycon, sfbuyval, sfsellcon, sfsellval, sfbuyoicon, sfbuyoival }) => (
                                                <tr>
                                                    <td className="text-left">Stock Futures </td>
                                                    <td className="text-right">{(sfbuycon != null) ? sfbuycon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sfbuyval != null) ? sfbuyval.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sfsellcon != null) ? sfsellcon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sfsellval != null) ? sfsellval.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sfbuyval != null && sfsellval != null) ? ((sfbuyval - sfsellval).toFixed(2)) : 0}</td>
                                                    <td className="text-right"> {(sfbuyoicon != null) ? sfbuyoicon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sfbuyoival != null) ? sfbuyoival.toFixed(2) : 0}</td>
                                                </tr>
                                            ))}
                                        {currentTableData && currentTableData.map(
                                            ({ sobuycon, sobuyval, sosellcon, sosellval, sobuyoicon, sobuyoival }) => (
                                                <tr>
                                                    <td className="text-left">Stock Options </td>
                                                    <td className="text-right">{(sobuycon != null) ? sobuycon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sobuyval != null) ? sobuyval.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sosellcon != null) ? sosellcon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sosellval != null) ? sosellval.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sobuyval != null && sosellcon != null) ? ((sobuyval - sosellcon).toFixed(2)) : 0}</td>
                                                    <td className="text-right"> {(sobuyoicon != null) ? sobuyoicon.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(sobuyoival != null) ? sobuyoival.toFixed(2) : 0}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default FIIStatistics;